// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__3-1ae"};